export class ReportOrgTreeNode {
  orgTreeNodeId: string;
  name: string;
  orgTreeNodeTypeName: string;
  assetFamilyName: string;

  loadFromJson(data) {
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.name = data.name;
    this.orgTreeNodeTypeName = data.orgTreeNodeTypeName;
    this.assetFamilyName = data.assetFamilyName;
  }
}
